<template>
  <BubbleChart
    :request-status="requestStatus"
    :title="title"
    :item-id="itemId"
    :series="series"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BubbleChart from '@/components/cards/models/BubbleChart';
import { mapActions } from 'vuex';
import proprietaryModel from '@/mixins/proprietary-model';
import channelModel from '@/mixins/channel-model';
import resolvers from '@/components/cards/engagement-matrix/resolvers';

export default {
  name: 'EngagementMatrixByPosts',
  components: {
    BubbleChart,
  },
  mixins: [
    channelModel,
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: 'posts',
    },
  },
  data() {
    const getTooltipHTML = (point) => this.resolver.getTooltipHTML(point);

    return {
      rawSeries: {},
      requestStatus: 'loading',
      cardOptions: {
        tooltip: {
          useHTML: true,
          formatter() {
            return getTooltipHTML(this.point);
          },
          followPointer: false,
          style: {
            pointerEvents: 'auto',
          },
          padding: 10,
        },
        xAxis: {
          tickWidth: 0,
          min: -100,
          max: 100,
          title: {
            text: this.$t('components.EngagementMatrix.label.sentimentIndex'),
          },
          labels: {
            format: '{value}',
          },
          plotLines: [{
            dashStyle: 'dash',
            width: 1,
            zIndex: 3,
          }],
        },
        yAxis: {
          labels: {
            format: '{value: .3f}',
          },
          maxPadding: 0.2,
          plotLines: [{
            dashStyle: 'dash',
            width: 1,
            zIndex: 3,
          }],
          tickWidth: 0,
          title: {
            text: this.$t('components.EngagementMatrix.label.engagementIndex'),
          },
        },
      },
    };
  },
  computed: {
    resolver() {
      return resolvers[this.type];
    },
    series() {
      return this.resolver.series(this.rawSeries);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getProprietaryMetricsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getProprietaryMetricsService({
        itemId: this.itemId,
        servicePath: this.resolver.servicePath,
      })
        .then(response => {
          this.rawSeries = response;

          this.cardOptions.xAxis.plotLines[0].value = this.rawSeries.net_sentiment_reference;
          this.cardOptions.yAxis.plotLines[0].value = this.rawSeries.engagement_rate_reference;

          this.requestStatus = 'success';
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
